import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { AppState } from '../../../../../../core/reducers';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FollowupReason } from '../../../../../../core/lists/_models/followup-reason.model';
import { FollowupReasonsService } from '../../../../../../core/lists/_services/followup-reasons.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-followup-reason-edit',
  templateUrl: './followup-reason-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FollowupReasonEditComponent implements OnInit, OnDestroy {
  reason: FollowupReason;
  companyId: number;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  reasonForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  subscriptions = [];

  constructor(
    public reasonService: FollowupReasonsService,
    public dialogRef: MatDialogRef<FollowupReasonEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private router: Router,
    private reasonFB: FormBuilder,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
  ) {}

  ngOnInit() {
    this.createForm();
  }

  getTitle() {
    if (this.data.mode === 'CREATE') return 'New Reason';
    return 'Update Reason - ' + this.data.reason.name;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  createForm() {
    this.reasonForm = this.reasonFB.group({
      reason: [this.data.reason ? this.data.reason.name : null],
    });
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.reasonForm.controls;
    if (this.reasonForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (this.data.mode === 'CREATE') {
      this.addReason(this.prepareReason());
      return;
    }
    this.updateReason(this.prepareReason());
  }

  prepareReason(): FollowupReason {
    const controls = this.reasonForm.controls;
    const _reason = new FollowupReason();
    if (this.data.mode === 'UPDATE') {
      _reason.id = this.data.reason.id;
    }
    _reason.name = controls.reason.value;
    return _reason;
  }

  addReason(_reason) {
    const request = {
      name: _reason.name,
    };
    this.reasonService.createReason(request).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Reason Added Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  updateReason(_reason) {
    const request = {
      id: _reason.id,
      name: _reason.name,
    };
    for (const [key, value] of Object.entries(request)) {
      if (typeof value === 'string') {
        request[key] = value.trim();
      }
    }
    this.reasonService.updateReason(request).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Reason Updated Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.reasonForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  close() {
    this.dialogRef.close();
  }
}
